module.exports = __webpack_public_path__ + "static/img/banner_product.b4616fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/banner_product.png
// module id = GbFA
// module chunks = 15